/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */
import { Action } from '@ngrx/store';

import { LocalizationPackage, LocalizationPackageAttributes } from '../../models/localization';

export const OPEN_TOOLBAR = '[THRESHOLD] Open Toolbar';
export const CLOSE_TOOLBAR = '[THRESHOLD] Close Toolbar';

export const SET_APPLICATION_TITLE = '[THRESHOLD] Set Application Title';
export const SET_APPLICATION_TITLE_SUCCESS = '[THRESHOLD] Set Application Title Success';

export const HIDE_BANNER = '[THRESHOLD] Hide Banner';
export const SHOW_BANNER = '[THRESHOLD] Show Banner';

export const HIDE_MENU = '[THRESHOLD] Hide Menu';
export const SHOW_MENU = '[THRESHOLD] Show Menu';

export const SET_BANNER_CLASS = '[THRESHOLD] Set Banner Class';
export const SET_BANNER_BACKGROUND = '[THRESHOLD] Set Banner Background';
export const SET_BANNER_TITLE = '[THRESHOLD] Set Banner Title';
export const SET_BANNER_CAPTION = '[THRESHOLD] Set Banner Caption';
export const SET_BANNER_ALIGN = '[THRESHOLD] Set Banner Align';

export const HIDE_BANNER_PROFILE = '[THRESHOLD] Hide Banner Profile';
export const SHOW_BANNER_PROFILE = '[THRESHOLD] Show Banner Profile';

export const HIDE_CONTEXT_NAV = '[THRESHOLD] Hide Context Nav';
export const SHOW_CONTEXT_NAV = '[THRESHOLD] Show Context Nav';
export const SET_CONTEXT_NAV = '[THRESHOLD] Set Context Nav';

export const SET_BREADCRUMB = '[THRESHOLD] Set Breadcrumb';

export const SET_MAIN_MENU = '[THRESHOLD] Set Main Menu';
export const SHOW_MAIN_MENU = '[THRESHOLD] Show Main Menu';
export const HIDE_MAIN_MENU = '[THRESHOLD] Hide Main Menu';

export const SET_SIZE = '[THRESHOLD] Set Size';
export const SET_VARIANT = '[THRESHOLD] Set Variant';
export const SET_COLOR = '[THRESHOLD] Set Color';

export const HIDE_SEARCH_CONTROL = '[THRESHOLD] Hide Search Control';
export const SHOW_SEARCH_CONTROL = '[THRESHOLD] Show Search Control';
export const TOGGLE_SEARCH_BAR = '[THRESHOLD] Toggle Search Bar';
export const FETCH_SEARCH_RESULTS = '[THRESHOLD] Fetch Search Results';
export const FETCH_SEARCH_RESULTS_SUCCESS = '[THRESHOLD] Fetch Search Results Request Success';

export const ADD_LOCALIZATION_PACKAGE = '[THRESHOLD LOCALIZATION] Add localization package';
export const SET_LOCALIZATION_DEFAULT_LANGUAGE = '[THRESHOLD LOCALIZATION] Set default localization language';
export const SET_LOCALIZATION_SUPPORTED_LANGUAGES = '[THRESHOLD LOCALIZATION] Set localization supported languages';
export const SET_LOCALIZATION_SUPPORTED_LANGUAGES_SUCCESS = '[THRESHOLD LOCALIZATION] Set localization supported languages success';
export const REFRESH_LANGUAGE = '[THRESHOLD LOCALIZATION] Refresh language localization';
export const LOADING_LANGUAGE = '[THRESHOLD LOCALIZATION] Starting to load language pack(s)';
export const LOADING_LANGUAGE_SUCCESS = '[THRESHOLD LOCALIZATION] Finished loading language pack(s)';

export const SET_DYNAMIC_MENU = '[THRESHOLD] Set Dynamic Menu';
export const SHOW_DYNAMIC_SMALL_MENU_WITH_NO_CHILDREN = '[THRESHOLD] Show Dynamic Small Menu With No Children';
export const HIDE_DYNAMIC_SMALL_MENU_WITH_NO_CHILDREN = '[THRESHOLD] Hide Dynamic Small Menu With No Children';

export const SET_USER_ACTIVITY = '[THRESHOLD] Set User Activity Feature';

export const SHOW_HEADER_MASTHEAD = '[THRESHOLD] Show Header Masthead';
export const HIDE_HEADER_MASTHEAD = '[THRESHOLD] Hide Header Masthead';

export const SET_ALLOW_EXTERNAL_NAVIGATION = '[THRESHOLD] Set allow external navigation';

export const SET_CONTAINER_CLASS = '[THRESHOLD] Set Container Class';

export class SetApplicationTitleAction implements Action { readonly type = SET_APPLICATION_TITLE; constructor(public payload: string) { } }
export class SetApplicationTitleSuccessAction implements Action { readonly type = SET_APPLICATION_TITLE_SUCCESS; }
export class SetBannerClassAction implements Action { readonly type = SET_BANNER_CLASS; constructor(public payload: string) { } }
export class SetBannerBackgroundAction implements Action { readonly type = SET_BANNER_BACKGROUND; constructor(public payload: string) { } }
export class SetBannerTitleAction implements Action { readonly type = SET_BANNER_TITLE;  constructor(public payload: string) { } }
export class SetBannerCaptionAction implements Action { readonly type = SET_BANNER_CAPTION;	constructor(public payload: string) { } }
export class SetBannerAlignAction implements Action { readonly type = SET_BANNER_ALIGN;	 constructor(public payload: string) { } }
export class ShowBannerAction implements Action { readonly type = SHOW_BANNER }
export class HideBannerAction implements Action { readonly type = HIDE_BANNER }

export class ShowMenuAction implements Action { readonly type = SHOW_MENU }
export class HideMenuAction implements Action { readonly type = HIDE_MENU }

export class ShowContextNavAction implements Action { readonly type = SHOW_CONTEXT_NAV }
export class HideContextNavAction implements Action { readonly type = HIDE_CONTEXT_NAV }
export class SetContextNavAction implements Action { readonly type = SET_CONTEXT_NAV; constructor(public payload: any) { } }

export class ShowMainMenuAction implements Action { readonly type = SHOW_MAIN_MENU }
export class HideMainMenuAction implements Action { readonly type = HIDE_MAIN_MENU }
export class SetMainMenuAction implements Action { readonly type = SET_MAIN_MENU; constructor(public payload: any) { } }

export class SetBreadcrumbAction implements Action { readonly type = SET_BREADCRUMB; constructor(public payload: any) { } }

export class SetColorAction implements Action { readonly type = SET_COLOR; constructor(public payload: any) { } }
export class SetVariantAction implements Action { readonly type = SET_VARIANT; constructor(public payload: any) { } }
export class SetSizeAction implements Action { readonly type = SET_SIZE; constructor(public payload: any) { } }

export class ShowProfileBannerAction implements Action { readonly type = SHOW_BANNER_PROFILE }
export class HideProfileBannerAction implements Action { readonly type = HIDE_BANNER_PROFILE }

export class OpenToolbarAction implements Action { readonly type = OPEN_TOOLBAR; }
export class CloseToolbarAction implements Action { readonly type = CLOSE_TOOLBAR; }

export class FetchSearchResultsAction implements Action { readonly type = FETCH_SEARCH_RESULTS; constructor(public payload: string) { } }
export class FetchSearchResultsSuccessAction implements Action { readonly type = FETCH_SEARCH_RESULTS_SUCCESS; constructor(public navigationSuccess: boolean) { } }
export class ShowSearchControlAction implements Action { readonly type = SHOW_SEARCH_CONTROL; }
export class HideSearchControlAction implements Action { readonly type = HIDE_SEARCH_CONTROL; }
export class ToggleSearchBarAction implements Action { readonly type = TOGGLE_SEARCH_BAR; }

export class SetDynamicMenuAction implements Action { readonly type = SET_DYNAMIC_MENU; constructor(public payload: any) { } }
export class ShowDynamicSmallMenuWithNoChildren implements Action { readonly type = SHOW_DYNAMIC_SMALL_MENU_WITH_NO_CHILDREN; }
export class HideDynamicSmallMenuWithNoChildren implements Action { readonly type = HIDE_DYNAMIC_SMALL_MENU_WITH_NO_CHILDREN; }

export class AddLocalizationPackageAction implements Action { readonly type = ADD_LOCALIZATION_PACKAGE; constructor(public payload: any) { } }
export class SetLocalizationDefaultLangAction implements Action { readonly type = SET_LOCALIZATION_DEFAULT_LANGUAGE; constructor(public payload: any) { } }
export class SetLocalizationSupportedLangsAction implements Action { readonly type = SET_LOCALIZATION_SUPPORTED_LANGUAGES; constructor(public payload: any) { } }
export class SetLocalizationSupportedLangsSuccessAction implements Action { readonly type = SET_LOCALIZATION_SUPPORTED_LANGUAGES_SUCCESS; }
export class RefreshLangAction implements Action { readonly type = REFRESH_LANGUAGE; }
export class LoadingLanguageAction implements Action { readonly type = LOADING_LANGUAGE; }
export class LoadingLanguageSuccessAction implements Action { readonly type = LOADING_LANGUAGE_SUCCESS; }

export class SetUserActivityAction implements Action { readonly type = SET_USER_ACTIVITY; constructor(public payload: any) { } }

export class ShowHeaderMastheadAction implements Action { readonly type = SHOW_HEADER_MASTHEAD; }
export class HideHeaderMastheadAction implements Action { readonly type = HIDE_HEADER_MASTHEAD; }

export class SetAllowExternalNavigationAction implements Action { readonly type = SET_ALLOW_EXTERNAL_NAVIGATION; constructor(public payload: any) { } }

export class SetContainerClassAction implements Action { readonly type = SET_CONTAINER_CLASS; constructor(public payload: string) { } }

export type Actions
	= SetBannerTitleAction
	| SetBannerClassAction
	| SetBannerBackgroundAction
	| SetApplicationTitleAction
	| SetBannerCaptionAction
	| SetBannerAlignAction
	| ShowContextNavAction
	| HideContextNavAction
	| SetContextNavAction
	| ShowProfileBannerAction
	| HideProfileBannerAction
	| ShowBannerAction
	| HideBannerAction
	| ShowMenuAction
	| HideMenuAction
	| ShowMainMenuAction
	| HideMainMenuAction
	| SetMainMenuAction
	| SetBreadcrumbAction
	| SetVariantAction
	| SetColorAction
	| SetSizeAction
	| ShowSearchControlAction
    | HideSearchControlAction
    | FetchSearchResultsAction
    | FetchSearchResultsSuccessAction
    | ToggleSearchBarAction
	| SetDynamicMenuAction
	| ShowDynamicSmallMenuWithNoChildren
	| HideDynamicSmallMenuWithNoChildren
	| AddLocalizationPackageAction
	| SetLocalizationDefaultLangAction
	| SetLocalizationSupportedLangsAction
	| SetLocalizationSupportedLangsSuccessAction
	| RefreshLangAction
	| LoadingLanguageAction
	| LoadingLanguageSuccessAction
	| SetUserActivityAction
	| ShowHeaderMastheadAction
	| HideHeaderMastheadAction
	| SetAllowExternalNavigationAction
	| SetContainerClassAction;



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/store/actions/actions.ts